module.exports = __webpack_public_path__ + "29f26ecbb067ba87d4f06caa0935933d.png";